import { IFormRegister } from 'routes/Main/type';

import Form from 'components/Form';
import RowContainer from '../components/RowContainer';
import RowContent from '../components/RowContent';
import SectionTitle from '../components/SectionTitle';

interface Props extends IFormRegister {
  disabled?: boolean;
}

const Signature = (props: Props) => {
  const { disabled, register } = props;

  const labels = [
    { title: '보고일', variable: 'date' },
    { title: '부서장 성명', variable: 'signature' },
    { title: '부서장 서명', variable: 'personnel_signature' },
  ];

  return (
    <>
      <RowContainer
        xs={12}
        sx={{ marginTop: '30px', marginLeft: '-20px', marginBottom: '100px' }}
      >
        {labels.map(({ title, variable }, _) => (
          <>
            {Array(3)
              .fill(0)
              .map(() => (
                <RowContent titleRatio={1} childrenRatio={1.9} />
              ))}
            {variable === 'date' ? (
              <RowContent
                key={variable}
                title={title}
                titleRatio={1}
                childrenRatio={2.1}
              >
                <Form.MuiTextField
                  type="date"
                  required={false}
                  disabled={disabled}
                  {...register(`${variable}`)}
                />
              </RowContent>
            ) : (
              <RowContent
                key={variable}
                title={title}
                titleRatio={1}
                childrenRatio={2.1}
              >
                <Form.MuiTextField
                  required={false}
                  disabled={disabled}
                  {...register(`${variable}`)}
                />
              </RowContent>
            )}
          </>
        ))}
      </RowContainer>
    </>
  );
};

export default Signature;
